import { c as _c } from "react/compiler-runtime";
import { IconLoader2 } from "@tabler/icons-react";
import { Button } from "@/components/ui/button";
interface Props {
  onRemove: () => void;
  onKeep: () => void;
  isPending: boolean;
}
export function RemoveConfirmation(t0) {
  const $ = _c(12);
  const {
    onRemove,
    onKeep,
    isPending
  } = t0;
  let t1;
  if ($[0] !== isPending) {
    t1 = isPending && <IconLoader2 className="animate-spin" />;
    $[0] = isPending;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = isPending ? "Removing..." : "Remove Item";
  let t3;
  if ($[2] !== isPending || $[3] !== onRemove || $[4] !== t1 || $[5] !== t2) {
    t3 = <Button variant="destructive" size="sm" className="flex-1" onClick={onRemove} disabled={isPending}>{t1}{t2}</Button>;
    $[2] = isPending;
    $[3] = onRemove;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== onKeep) {
    t4 = <Button variant="outline" size="sm" className="flex-1" onClick={onKeep}>Keep Item</Button>;
    $[7] = onKeep;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="flex items-center gap-2 px-5 py-2">{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}